import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { useLang } from "@/i18n";
import { legalTranslations } from "@/i18n/legal";

const sections = [
  {
    h2: "1. Titolare del trattamento",
    text: "DJ Magix, con base a Lugano-Paradiso (Ticino, Svizzera). Contatti: info@djmagix.net — Tel +41 76 441 13 59. Per qualsiasi domanda sui tuoi dati puoi scrivere a questo indirizzo.",
  },
  {
    h2: "2. Quali dati raccogliamo",
    text: "Modulo contatti e preventivo: nome, email, telefono e dettagli dell'evento che ci invii volontariamente, usati unicamente per risponderti e preparare il preventivo. Strumenti di analisi (solo con il tuo consenso): Google Analytics 4 con indirizzo IP anonimizzato e Microsoft Clarity, che registrano in forma aggregata come viene usato il sito (pagine visitate, clic, movimento del mouse). Con lo stesso consenso registriamo anche statistiche di visita interne in forma anonima (indirizzo IP abbreviato, città approssimativa, tipo di dispositivo), visibili solo al titolare nella sua dashboard.",
  },
  {
    h2: "3. Base giuridica e consenso",
    text: "Il trattamento dei dati del modulo si basa sulla tua richiesta di contatto. Gli strumenti di analisi vengono caricati solo dopo il tuo consenso esplicito tramite il banner cookie; puoi rifiutare senza alcuna conseguenza sulla navigazione e cambiare idea in qualsiasi momento dal link 'Preferenze cookie' nel piè di pagina.",
  },
  {
    h2: "4. Condivisione e conservazione",
    text: "I tuoi dati non vengono venduti né ceduti a terzi per scopi di marketing. Conservazione: le richieste di preventivo non più attive (lead mai convertiti o persi) vengono eliminate automaticamente dopo 24 mesi; i dati di analisi anonimi (visite) dopo 12 mesi; i consensi privacy e newsletter sono registrati in un registro dedicato (data, testo accettato, IP anonimizzato) come prova del consenso. L'iscrizione alla newsletter avviene solo con il tuo consenso esplicito e puoi cancellarti con un click in ogni email. Puoi chiedere la cancellazione dei tuoi dati in qualsiasi momento.",
  },
  {
    h2: "5. I tuoi diritti (LPD e GDPR)",
    text: "In base alla Legge federale sulla protezione dei dati (LPD) e, se applicabile, al GDPR, hai diritto di accesso, rettifica, cancellazione e opposizione al trattamento dei tuoi dati. Per esercitarli scrivi a info@djmagix.net: risponderemo personalmente.",
  },
  {
    h2: "6. Modifiche a questa policy",
    text: "Questa informativa può essere aggiornata nel tempo; la versione pubblicata su questa pagina è quella vigente. Ultimo aggiornamento: ottobre 2026.",
  },
];

const it = {
  title: "Privacy Policy | DJMAGIX",
  description: "Informativa privacy di DJ Magix: quali dati raccogliamo, come li usiamo e i tuoi diritti secondo la LPD svizzera e il GDPR.",
  eyebrow: "Documento Legale",
  heading: "Privacy Policy",
  sections,
};

export default function Privacy() {
  const lang = useLang();
  const t = legalTranslations[lang]?.privacy || it;
  const path = lang === "it" ? "/privacy" : `/${lang}/privacy`;
  const alternates = [
    { hreflang: "it", path: "/privacy" },
    { hreflang: "en", path: "/en/privacy" },
    { hreflang: "de", path: "/de/privacy" },
    { hreflang: "x-default", path: "/privacy" },
  ];
  return (
    <>
      <Seo title={t.title} description={t.description} path={path} lang={lang} alternates={alternates} />
      <section className="pt-40 pb-24 max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#BFA45D] font-medium text-center">
            {t.eyebrow}
          </p>
          <h1
            data-testid="privacy-heading"
            className="font-display text-3xl sm:text-4xl font-bold tracking-tight gold-text mt-4 text-center"
          >
            {t.heading}
          </h1>
          <div className="mt-12">
            {t.sections.map((s) => (
              <div key={s.h2} className="mb-8">
                <h2 className="font-display text-lg sm:text-xl font-semibold text-[#F7DE8B]">
                  {s.h2}
                </h2>
                <p className="text-base text-[#E2C882]/85 leading-relaxed mt-3">{s.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </section>
    </>
  );
}
